import { PropertyIcon } from "common/components/map/PropertyIcon";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { mainPropertyBGColor } from "../../hooks/propertyIcons.hooks";
import { ValuationZoneIcon } from "./ValuationZoneIcon";
import colors from "common/styles/colors";

export const useAddonMapLegendItems = ({
  includeMyProperty = true,
  includeValuationZones = false,
}: {
  includeMyProperty?: boolean;
  includeValuationZones?: boolean;
}) => {
  const { t } = useTranslation();
  return useMemo(() => {
    const myPropertyItems = includeMyProperty
      ? [
          {
            icon: <PropertyIcon backgroundColor={mainPropertyBGColor} />,
            label: t("addonMap.legend.myProperty"),
          },
        ]
      : [];
    const valuationZoneItems = includeValuationZones
      ? [
          {
            icon: <ValuationZoneIcon color={colors.green} />,
            label: t("addonMap.legend.valuationZoneWithResults"),
          },
          {
            icon: <ValuationZoneIcon color={colors.red} />,
            label: t("addonMap.legend.valuationZoneWithoutResults"),
          },
        ]
      : [];
    return [...myPropertyItems, ...valuationZoneItems];
  }, [includeMyProperty, includeValuationZones, t]);
};
